module.exports = __webpack_public_path__ + "img/plot-book-logo-original.3eead55d.svg";